import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { gzip } from 'pako';
import { GZIP_REQUEST } from './gzip-request.context';

export const gzipRequestInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  // Only compress if the caller explicitly opted in via GZIP_REQUEST context
  if (!req.context.get(GZIP_REQUEST)) {
    return next(req);
  }

  // Only compress requests that have a body
  if (!req.body || req.method === 'GET' || req.method === 'DELETE') {
    return next(req);
  }

  const jsonBody = JSON.stringify(req.body);
  const compressed = gzip(jsonBody);

  const compressedReq = req.clone({
    body: compressed,
    headers: req.headers
      .set('Content-Encoding', 'gzip')
      .set('Content-Type', 'application/json'),
  });

  return next(compressedReq);
};